module.exports = __webpack_public_path__ + "static/media/mico-leao-dourado.8c3b85ec.webp";